// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700;800&display=swap'); */

/* Page */
.daPage {
  background: var(--white-principale);
  min-height: 100vh;
  padding: 16px 0 26px;

  font-family: "Lato", sans-serif;
  letter-spacing: 0;
}

/* Breadcrumb (version composant) */
.daBreadcrumbWrap {
  padding-top: 10px;
  /* descend réellement le breadcrumb */
  margin-bottom: 14px;
}

/* Bouton signalement (même thème daBtn, variante danger) */
/* Bouton signalement */
.daBtnDanger {
  background: var(--couleur-principale);
  /* même thème par défaut */
  color: var(--white-principale);
  transition: background .15s ease, filter .15s ease;
}

/* ✅ au survol : devient rouge */
.daBtnDanger:hover {
  background: #dc2626;
  /* rouge */
  filter: none;
}



/* Breadcrumb */
.daBreadcrumb {
  font-size: 14px; /* était 16px, un peu grand pour un fil d'ariane */
  color: var(--gris-terciaire);
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 14px;

  font-family: "Lato", sans-serif;
  letter-spacing: 0;
}

.daBreadcrumb .sep {
  color: var(--gris-principale);
}

.daBreadcrumb .active {
  color: var(--couleur-principale);
  font-weight: 700;
}

/* Main layout: left content + right card */
.daGrid {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 22px;
  align-items: start;
}

/* ===== LEFT ===== */
.daMedia {
  position: relative;
}

/* Media layout like screenshot:
   big image left + 2 small stacked on right */
.daMediaGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  align-items: stretch;
}

.daMain {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);
  background: var(--white-principale);
  height: 384px;
}

.daMainImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Right thumbnails column */
.daThumbs {
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: 384px;
}

.daThumb {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);
  cursor: pointer;
  position: relative;
  border: 2px solid transparent;
  background: var(--white-principale);
}

.daThumbImg {
  width: 100%;
  height: 192px;
  object-fit: cover;
  display: block;
}

/* Carousel buttons */
.daCarBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 999px;

  background: rgba(0, 0, 0, .55);
  color: var(--white-principale);

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.daCarBtn:hover {
  background: rgba(0, 0, 0, .75);
}

.daCarBtnLeft {
  left: 10px;
}

.daCarBtnRight {
  right: 10px;
}

/* Details under media */
.daDetails {
  margin-top: 40px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--gris-secondaire-2);
}

/* Titre annonce (24px bold) */
.daTitle {
  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-title);
  font-size: var(--font-size-detail-title);
  line-height: 1.3;
  letter-spacing: 0;

  color: var(--couleur-dark);
  margin: 8px 0 10px;
}


/* Prix (20px bold) */
.daPrice {
  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-price);
  font-size: var(--font-size-detail-price);
  line-height: 1.3;
  letter-spacing: 0;

  color: var(--couleur-secondaire);
  margin-bottom: 10px;
}


/* Ville (16px regular) */
.daCity {
  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-detail-meta);
  line-height: 1.4;
  letter-spacing: 0;

  color: var(--couleur-dark);
  margin-bottom: 8px;
}

/* Date (16px regular) => même couleur que ville */
.daDate {
  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-detail-meta);
  line-height: 1.4;
  letter-spacing: 0;

  color: var(--couleur-dark);
}

/* Info keys section */
.daInfoBlock {
  margin-top: 14px;
}

/* Titre "Les informations clés" (20px regular) */
.daInfoTitle {
  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-detail-section);
  line-height: 1.3;
  letter-spacing: 0;

  color: var(--couleur-principale);
  margin-bottom: 16px;
}

/* Grille infos */
.daInfoRows {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 18px;
}

.daInfoRow {
  display: flex;
  gap: 10px;
  align-items: center;

  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-detail-text);
  line-height: 1.4;
  letter-spacing: 0;
}
/* Clé (Marque, Modèle...) */
.daInfoKey {
  color: var(--couleur-secondaire);
  font-weight: 400;
  min-width: 74px;
}

/* Valeur (DODGE, etc.) */
.daInfoVal {
  color: var(--couleur-dark);
  font-weight: 400;
}

/* Souligner uniquement DODGE (valeur Marque) */
.daInfoRow:first-child .daInfoVal {
  font-weight: 700;
  font-size: 13px;
  text-decoration: underline;
}

/* ===== RIGHT CARD (seller) ===== */
.daRight {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.daCard {
  border-radius: 16px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);
  padding: 14px;
}

.daSellerTop {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
}

/* Avatar 60x60 */
.daAvatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
  background: var(--gris-secondaire-2);
  overflow: hidden;
  flex: 0 0 auto;
}

.daAvatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* MG MOTORS (20px bold) */
.daSellerName {
  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-title);
  font-size: var(--font-size-seller-name);
  line-height: 1.3;
  letter-spacing: 0;

  color: var(--couleur-dark);
}

/* 30 annonces (15px regular) */
.daSellerMeta {
  font-family: "Lato", sans-serif;
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-seller-meta);
  line-height: 1.3;
  letter-spacing: 0;

  color: var(--gris-terciaire);
  margin-top: 6px;
}

/* Buttons */
.daBtn {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 999px;

  background: var(--couleur-principale);
  color: var(--white-principale);

  font-family: "Lato", sans-serif;
  font-weight: 700;
  letter-spacing: 0;

  cursor: pointer;
  transition: background .15s ease, filter .15s ease;
}

.daBtn_signaler {
  width: 20%;
  height: 40px;
  border: none;
  border-radius: 999px;

  background: var(--orange-secondaire);
  color: var(--white-principale);

  font-family: "Lato", sans-serif;
  font-weight: 700;
  letter-spacing: 0;

  cursor: pointer;
  transition: background .15s ease, filter .15s ease;
}

.daBtn:hover {
  filter: brightness(.95);
}

.daBtn_signaler:hover {
  filter: brightness(.95);
  background: var(--couleur-secondaire);
}

/* WhatsApp (✅ alignement logo + texte) */
.daBtnWhatsapp {
  border: 1px solid var(--vert-principale);
  color: var(--vert-principale);
  background: none;
  margin-top: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 14px;
}

.daWhatsappIcon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
  flex: 0 0 auto;
}

.daBtnWhatsapp span {
  line-height: 1;
}

.daBtnWhatsapp:hover {
  background: rgba(0, 200, 83, 0.08);
  filter: none;
}

.btnIconFacebook {
  border: 1px solid var(--bleu-facebook);
  color: var(--bleu-facebook);
  background: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 14px;
  width: 200px;
}

.btnIconFacebook i {
  color: var(--bleu-facebook);
  font-size: 1.2em;
}

.btnIconFacebook span {
  line-height: 1;
  color: var(--couleur-dark);
}

.btnIconFacebook:hover {
  background: var(--bleu-facebook);
  filter: none;
}

.btnIconFacebook:hover i {
  color: var(--white-principale);
}

.btnIconFacebook:hover span {
  line-height: 1;
  color: var(--white-principale);
}

.article-detail-etat-partagefacebook {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

/* =========================================================
   Bouton "Voir les images" — style Leboncoin + floating
   ========================================================= */

/* Base bouton (beau, pill, compteur) */
.daViewImagesBtn {
  width: 100%;
  height: 46px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, .14);
  background: rgba(255, 255, 255, .92);
  box-shadow: 0 10px 26px rgba(0, 0, 0, .12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  color: var(--couleur-dark);
  font-weight: 800;
  font-family: "Lato", sans-serif;
  letter-spacing: 0;
  transition: transform .15s ease, filter .15s ease, background-color .2s ease;
}

.daViewImagesBtn i {
  font-size: 18px;
  color: var(--couleur-principale);
}

.daViewImagesBtn em {
  font-style: normal;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(37, 99, 235, .12);
  color: var(--couleur-principale);
  font-weight: 800;
}

.daViewImagesBtn:hover {
  transform: translateY(-1px);
  filter: brightness(.99);
  background: rgba(255, 255, 255, .98);
}

.daViewImagesBtn:disabled {
  opacity: .55;
  cursor: not-allowed;
  transform: none;
}

/* ✅ Version flottante (overlay) : toujours visible, même mobile */
.daViewImagesBtnFloating {
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: auto;
  padding: 0 14px;
  z-index: 5;
}

/* Si tu veux que le bouton soit légèrement “glass” */
.daViewImagesBtnFloating {
  backdrop-filter: blur(8px);
}

.texte_description {
  font-size: var(--font-size-detail-text);
  color: var(--couleur-dark);
  margin-left: 0;
  font-weight: var(--font-weight-normal);
  line-height: 1.5;
  white-space: pre-wrap;
}

.daEtatArticle {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 600;
  color: var(--couleur-secondaire);
}

/* Mobile : le bouton reste, plus compact */
@media (max-width: 720px) {
  .daViewImagesBtnFloating {
    right: 10px;
    bottom: 10px;
    height: 42px;
    padding: 0 12px;
  }

  .daViewImagesBtnFloating span {
    font-size: 14px;
  }

  .daViewImagesBtnFloating i {
    font-size: 17px;
  }
}


/* ===== Responsive ===== */
@media (max-width: 992px) {
  .daGrid {
    grid-template-columns: 1fr;
  }

  .daRight {
    max-width: 420px;
  }

  .daTitle {
    font-size: 22px;
  }

  .daBtn_signaler {
    width: 100%;
  }

  .article-detail-etat-partagefacebook {
    align-items: flex-start;
    flex-direction: column;
  }
}

.daMediaStage {
  position: relative;
}

/* Ajuste la hauteur "réelle" du stage (desktop) */
.daMediaStage .daMediaGrid {
  /* rien d'obligatoire, mais utile si tu veux une base stable */
}

/* ✅ Remonte un peu les boutons (au lieu de 50% pile) */
.daCarBtn {
  top: 44%;
  transform: translateY(-50%);
}

.daReportLink {
  width: 100%;
  margin-top: 10px;
  border: none;
  background: transparent;
  color: var(--gris-terciaire);
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
}

.daReportLink:hover {
  color: #dc2626;
}


@media (min-width: 993px) {
  .daCarBtn {
    top: 42%;
  }
}

@media (max-width: 720px) {
  .daMediaGrid {
    grid-template-columns: 1fr;
    height: 321px;
    overflow: hidden;
  }

  .daMain {
    height: 320px;
  }

  .daMainImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }


  .daThumbs {
    flex-direction: row;
    overflow-x: auto;
    padding: 2px;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }

  .daThumbs::-webkit-scrollbar {
    height: 0;
  }

  .daThumbs {
    scrollbar-width: none;
  }

  .daThumb {
    flex: 0 0 62%;
  }

  .daThumbImg {
    height: 120px;
  }

  .daInfoRows {
    grid-template-columns: 1fr;
  }

  .daGrid {
    display: flex;
    flex-direction: column-reverse;
    gap: 16px;

  }

  /* Le bloc vendeur en premier (en haut) */
  .daRight {
    order: -1;
    width: 100%;
    max-width: none;
  }

  /* La partie gauche ensuite */
  .daLeft {
    order: 0;
    width: 100%;
  }

  /* Optionnel : éviter que la card colle aux bords */
  .daCard {
    width: 100%;
  }

  .daBtn_signaler {
    width: 100%;
  }

  .daMediaStage {
    /* évite que les boutons sortent */
    border-radius: 14px;
  }

  .daCarBtn {
    width: 36px;
    height: 36px;
    top: 50%;
    /* sur mobile le centre est OK */
  }

  .daCarBtnLeft {
    left: 8px;
  }

  .daCarBtnRight {
    right: 8px;
  }

  .article-detail-etat-partagefacebook {
    align-items: flex-start;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/detail-annonces/DetailAnnonce.css"],"names":[],"mappings":"AAAA,gGAAgG;;AAEhG,SAAS;AACT;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;;EAEpB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D,uBAAuB;AACvB;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;;;AAIA,eAAe;AACf;EACE,eAAe,EAAE,kDAAkD;EACnE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;;EAElB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;8CAC8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;;EAEpB,8BAA8B;EAC9B,8BAA8B;;EAE9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;;EAEjB,0BAA0B;EAC1B,kBAAkB;AACpB;;;AAGA,qBAAqB;AACrB;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;;EAEjB,gCAAgC;EAChC,mBAAmB;AACrB;;;AAGA,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;;EAEjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;;EAEjB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;;EAEjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB,+BAA+B;EAC/B,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;AACA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;;EAEjB,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;;EAEjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;;EAEpB,qCAAqC;EACrC,8BAA8B;;EAE9B,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,oBAAoB;;EAEpB,oCAAoC;EACpC,8BAA8B;;EAE9B,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,yCAAyC;AACzC;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;8DAE8D;;AAE9D,uCAAuC;AACvC;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uCAAuC;EACvC,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA,qDAAqD;AACrD;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;EACE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,8DAA8D;AAChE;;AAEA,uDAAuD;AACvD;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;;EAEX;;EAEA,yCAAyC;EACzC;IACE,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,QAAQ;IACR,WAAW;EACb;;EAEA,mDAAmD;EACnD;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,gCAAgC;EAClC;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700;800&display=swap'); */\n\n/* Page */\n.daPage {\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 16px 0 26px;\n\n  font-family: \"Lato\", sans-serif;\n  letter-spacing: 0;\n}\n\n/* Breadcrumb (version composant) */\n.daBreadcrumbWrap {\n  padding-top: 10px;\n  /* descend réellement le breadcrumb */\n  margin-bottom: 14px;\n}\n\n/* Bouton signalement (même thème daBtn, variante danger) */\n/* Bouton signalement */\n.daBtnDanger {\n  background: var(--couleur-principale);\n  /* même thème par défaut */\n  color: var(--white-principale);\n  transition: background .15s ease, filter .15s ease;\n}\n\n/* ✅ au survol : devient rouge */\n.daBtnDanger:hover {\n  background: #dc2626;\n  /* rouge */\n  filter: none;\n}\n\n\n\n/* Breadcrumb */\n.daBreadcrumb {\n  font-size: 14px; /* était 16px, un peu grand pour un fil d'ariane */\n  color: var(--gris-terciaire);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 4px 0 14px;\n\n  font-family: \"Lato\", sans-serif;\n  letter-spacing: 0;\n}\n\n.daBreadcrumb .sep {\n  color: var(--gris-principale);\n}\n\n.daBreadcrumb .active {\n  color: var(--couleur-principale);\n  font-weight: 700;\n}\n\n/* Main layout: left content + right card */\n.daGrid {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 22px;\n  align-items: start;\n}\n\n/* ===== LEFT ===== */\n.daMedia {\n  position: relative;\n}\n\n/* Media layout like screenshot:\n   big image left + 2 small stacked on right */\n.daMediaGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  align-items: stretch;\n}\n\n.daMain {\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);\n  background: var(--white-principale);\n  height: 384px;\n}\n\n.daMainImg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Right thumbnails column */\n.daThumbs {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  height: 384px;\n}\n\n.daThumb {\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);\n  cursor: pointer;\n  position: relative;\n  border: 2px solid transparent;\n  background: var(--white-principale);\n}\n\n.daThumbImg {\n  width: 100%;\n  height: 192px;\n  object-fit: cover;\n  display: block;\n}\n\n/* Carousel buttons */\n.daCarBtn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 42px;\n  height: 42px;\n  border: none;\n  border-radius: 999px;\n\n  background: rgba(0, 0, 0, .55);\n  color: var(--white-principale);\n\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n}\n\n.daCarBtn:hover {\n  background: rgba(0, 0, 0, .75);\n}\n\n.daCarBtnLeft {\n  left: 10px;\n}\n\n.daCarBtnRight {\n  right: 10px;\n}\n\n/* Details under media */\n.daDetails {\n  margin-top: 40px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--gris-secondaire-2);\n}\n\n/* Titre annonce (24px bold) */\n.daTitle {\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-title);\n  font-size: var(--font-size-detail-title);\n  line-height: 1.3;\n  letter-spacing: 0;\n\n  color: var(--couleur-dark);\n  margin: 8px 0 10px;\n}\n\n\n/* Prix (20px bold) */\n.daPrice {\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-price);\n  font-size: var(--font-size-detail-price);\n  line-height: 1.3;\n  letter-spacing: 0;\n\n  color: var(--couleur-secondaire);\n  margin-bottom: 10px;\n}\n\n\n/* Ville (16px regular) */\n.daCity {\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-normal);\n  font-size: var(--font-size-detail-meta);\n  line-height: 1.4;\n  letter-spacing: 0;\n\n  color: var(--couleur-dark);\n  margin-bottom: 8px;\n}\n\n/* Date (16px regular) => même couleur que ville */\n.daDate {\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-normal);\n  font-size: var(--font-size-detail-meta);\n  line-height: 1.4;\n  letter-spacing: 0;\n\n  color: var(--couleur-dark);\n}\n\n/* Info keys section */\n.daInfoBlock {\n  margin-top: 14px;\n}\n\n/* Titre \"Les informations clés\" (20px regular) */\n.daInfoTitle {\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-normal);\n  font-size: var(--font-size-detail-section);\n  line-height: 1.3;\n  letter-spacing: 0;\n\n  color: var(--couleur-principale);\n  margin-bottom: 16px;\n}\n\n/* Grille infos */\n.daInfoRows {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 18px;\n}\n\n.daInfoRow {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-normal);\n  font-size: var(--font-size-detail-text);\n  line-height: 1.4;\n  letter-spacing: 0;\n}\n/* Clé (Marque, Modèle...) */\n.daInfoKey {\n  color: var(--couleur-secondaire);\n  font-weight: 400;\n  min-width: 74px;\n}\n\n/* Valeur (DODGE, etc.) */\n.daInfoVal {\n  color: var(--couleur-dark);\n  font-weight: 400;\n}\n\n/* Souligner uniquement DODGE (valeur Marque) */\n.daInfoRow:first-child .daInfoVal {\n  font-weight: 700;\n  font-size: 13px;\n  text-decoration: underline;\n}\n\n/* ===== RIGHT CARD (seller) ===== */\n.daRight {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.daCard {\n  border-radius: 16px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);\n  padding: 14px;\n}\n\n.daSellerTop {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n/* Avatar 60x60 */\n.daAvatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 999px;\n  background: var(--gris-secondaire-2);\n  overflow: hidden;\n  flex: 0 0 auto;\n}\n\n.daAvatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* MG MOTORS (20px bold) */\n.daSellerName {\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-title);\n  font-size: var(--font-size-seller-name);\n  line-height: 1.3;\n  letter-spacing: 0;\n\n  color: var(--couleur-dark);\n}\n\n/* 30 annonces (15px regular) */\n.daSellerMeta {\n  font-family: \"Lato\", sans-serif;\n  font-weight: var(--font-weight-normal);\n  font-size: var(--font-size-seller-meta);\n  line-height: 1.3;\n  letter-spacing: 0;\n\n  color: var(--gris-terciaire);\n  margin-top: 6px;\n}\n\n/* Buttons */\n.daBtn {\n  width: 100%;\n  height: 40px;\n  border: none;\n  border-radius: 999px;\n\n  background: var(--couleur-principale);\n  color: var(--white-principale);\n\n  font-family: \"Lato\", sans-serif;\n  font-weight: 700;\n  letter-spacing: 0;\n\n  cursor: pointer;\n  transition: background .15s ease, filter .15s ease;\n}\n\n.daBtn_signaler {\n  width: 20%;\n  height: 40px;\n  border: none;\n  border-radius: 999px;\n\n  background: var(--orange-secondaire);\n  color: var(--white-principale);\n\n  font-family: \"Lato\", sans-serif;\n  font-weight: 700;\n  letter-spacing: 0;\n\n  cursor: pointer;\n  transition: background .15s ease, filter .15s ease;\n}\n\n.daBtn:hover {\n  filter: brightness(.95);\n}\n\n.daBtn_signaler:hover {\n  filter: brightness(.95);\n  background: var(--couleur-secondaire);\n}\n\n/* WhatsApp (✅ alignement logo + texte) */\n.daBtnWhatsapp {\n  border: 1px solid var(--vert-principale);\n  color: var(--vert-principale);\n  background: none;\n  margin-top: 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 0 14px;\n}\n\n.daWhatsappIcon {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n  display: block;\n  flex: 0 0 auto;\n}\n\n.daBtnWhatsapp span {\n  line-height: 1;\n}\n\n.daBtnWhatsapp:hover {\n  background: rgba(0, 200, 83, 0.08);\n  filter: none;\n}\n\n.btnIconFacebook {\n  border: 1px solid var(--bleu-facebook);\n  color: var(--bleu-facebook);\n  background: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 0 14px;\n  width: 200px;\n}\n\n.btnIconFacebook i {\n  color: var(--bleu-facebook);\n  font-size: 1.2em;\n}\n\n.btnIconFacebook span {\n  line-height: 1;\n  color: var(--couleur-dark);\n}\n\n.btnIconFacebook:hover {\n  background: var(--bleu-facebook);\n  filter: none;\n}\n\n.btnIconFacebook:hover i {\n  color: var(--white-principale);\n}\n\n.btnIconFacebook:hover span {\n  line-height: 1;\n  color: var(--white-principale);\n}\n\n.article-detail-etat-partagefacebook {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n/* =========================================================\n   Bouton \"Voir les images\" — style Leboncoin + floating\n   ========================================================= */\n\n/* Base bouton (beau, pill, compteur) */\n.daViewImagesBtn {\n  width: 100%;\n  height: 46px;\n  border-radius: 999px;\n  border: 1px solid rgba(15, 23, 42, .14);\n  background: rgba(255, 255, 255, .92);\n  box-shadow: 0 10px 26px rgba(0, 0, 0, .12);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n  color: var(--couleur-dark);\n  font-weight: 800;\n  font-family: \"Lato\", sans-serif;\n  letter-spacing: 0;\n  transition: transform .15s ease, filter .15s ease, background-color .2s ease;\n}\n\n.daViewImagesBtn i {\n  font-size: 18px;\n  color: var(--couleur-principale);\n}\n\n.daViewImagesBtn em {\n  font-style: normal;\n  font-size: 12px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(37, 99, 235, .12);\n  color: var(--couleur-principale);\n  font-weight: 800;\n}\n\n.daViewImagesBtn:hover {\n  transform: translateY(-1px);\n  filter: brightness(.99);\n  background: rgba(255, 255, 255, .98);\n}\n\n.daViewImagesBtn:disabled {\n  opacity: .55;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ✅ Version flottante (overlay) : toujours visible, même mobile */\n.daViewImagesBtnFloating {\n  position: absolute;\n  right: 14px;\n  bottom: 14px;\n  width: auto;\n  padding: 0 14px;\n  z-index: 5;\n}\n\n/* Si tu veux que le bouton soit légèrement “glass” */\n.daViewImagesBtnFloating {\n  backdrop-filter: blur(8px);\n}\n\n.texte_description {\n  font-size: var(--font-size-detail-text);\n  color: var(--couleur-dark);\n  margin-left: 0;\n  font-weight: var(--font-weight-normal);\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.daEtatArticle {\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--couleur-secondaire);\n}\n\n/* Mobile : le bouton reste, plus compact */\n@media (max-width: 720px) {\n  .daViewImagesBtnFloating {\n    right: 10px;\n    bottom: 10px;\n    height: 42px;\n    padding: 0 12px;\n  }\n\n  .daViewImagesBtnFloating span {\n    font-size: 14px;\n  }\n\n  .daViewImagesBtnFloating i {\n    font-size: 17px;\n  }\n}\n\n\n/* ===== Responsive ===== */\n@media (max-width: 992px) {\n  .daGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .daRight {\n    max-width: 420px;\n  }\n\n  .daTitle {\n    font-size: 22px;\n  }\n\n  .daBtn_signaler {\n    width: 100%;\n  }\n\n  .article-detail-etat-partagefacebook {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.daMediaStage {\n  position: relative;\n}\n\n/* Ajuste la hauteur \"réelle\" du stage (desktop) */\n.daMediaStage .daMediaGrid {\n  /* rien d'obligatoire, mais utile si tu veux une base stable */\n}\n\n/* ✅ Remonte un peu les boutons (au lieu de 50% pile) */\n.daCarBtn {\n  top: 44%;\n  transform: translateY(-50%);\n}\n\n.daReportLink {\n  width: 100%;\n  margin-top: 10px;\n  border: none;\n  background: transparent;\n  color: var(--gris-terciaire);\n  cursor: pointer;\n  font-size: 12px;\n  text-decoration: underline;\n}\n\n.daReportLink:hover {\n  color: #dc2626;\n}\n\n\n@media (min-width: 993px) {\n  .daCarBtn {\n    top: 42%;\n  }\n}\n\n@media (max-width: 720px) {\n  .daMediaGrid {\n    grid-template-columns: 1fr;\n    height: 321px;\n    overflow: hidden;\n  }\n\n  .daMain {\n    height: 320px;\n  }\n\n  .daMainImg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    display: block;\n  }\n\n\n  .daThumbs {\n    flex-direction: row;\n    overflow-x: auto;\n    padding: 2px;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .daThumbs::-webkit-scrollbar {\n    height: 0;\n  }\n\n  .daThumbs {\n    scrollbar-width: none;\n  }\n\n  .daThumb {\n    flex: 0 0 62%;\n  }\n\n  .daThumbImg {\n    height: 120px;\n  }\n\n  .daInfoRows {\n    grid-template-columns: 1fr;\n  }\n\n  .daGrid {\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 16px;\n\n  }\n\n  /* Le bloc vendeur en premier (en haut) */\n  .daRight {\n    order: -1;\n    width: 100%;\n    max-width: none;\n  }\n\n  /* La partie gauche ensuite */\n  .daLeft {\n    order: 0;\n    width: 100%;\n  }\n\n  /* Optionnel : éviter que la card colle aux bords */\n  .daCard {\n    width: 100%;\n  }\n\n  .daBtn_signaler {\n    width: 100%;\n  }\n\n  .daMediaStage {\n    /* évite que les boutons sortent */\n    border-radius: 14px;\n  }\n\n  .daCarBtn {\n    width: 36px;\n    height: 36px;\n    top: 50%;\n    /* sur mobile le centre est OK */\n  }\n\n  .daCarBtnLeft {\n    left: 8px;\n  }\n\n  .daCarBtnRight {\n    right: 8px;\n  }\n\n  .article-detail-etat-partagefacebook {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
